<template>
  <div class="row h-100">
    <div class="col-12 h-100 d-flex flex-column">
      <div class="mb-4">
        <div v-if="showSelect" style="overflow: hidden">
          <b-button
            class="action-button"
            :variant="`${selectedApp === 'reports' ? '' : 'outline-'}primary`"
            size="sm"
            @click="selectedApp = 'reports'"
          >
            {{ 'REPORTS' | i18n }}
          </b-button>
          <b-button
            class="action-button"
            :variant="`${selectedApp === 'one' ? '' : 'outline-'}primary`"
            size="sm"
            style="margin-left: 15px"
            @click="selectedApp = 'one'"
          >
            {{ 'ONE' | i18n }}
          </b-button>
        </div>
      </div>

      <Report v-if="(showSelect && selectedApp === 'reports') || (!showSelect && isReportModule)" />
      <One v-if="(showSelect && selectedApp === 'one') || (!showSelect && isONEProject)" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { LicenseMixin } from '../../../../mixins';

import Report from '../Report';
import One from '../One';

export default {
  name: 'Dashboard',
  components: { Report, One },
  mixins: [LicenseMixin],
  data: function () {
    return {
      baseURL: axios.defaults.baseURL,
      selectedApp: 'reports',
    };
  },
  computed: {
    showSelect: function () {
      return this.isONEProject && this.isReportModule;
    },
  },
};
</script>

<style scoped lang="scss">
.img-box {
  display: flex;
  justify-content: center;
  width: 100%;
  top: 11px;
  left: 0;
}
</style>
